import { render, staticRenderFns } from "./TagInputs.vue?vue&type=template&id=728880b6&"
import script from "./TagInputs.vue?vue&type=script&lang=ts&"
export * from "./TagInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports